import axios from "axios";

//—— 動線打點 ——
//
//  在七個節點各打一筆，回答「人在哪一段掉的」——
//  訂單只記得最後兩段（建單、付款），前面全是黑的。
//
//  節點的清單與順序在後端的 config/funnel.js，那裡是唯一真相；
//  這支只負責把字串送出去，後端有白名單會擋掉打錯的。
//
//  —— 三個刻意的設計 ——
//
//  1. **永遠不丟例外、也不回傳任何東西。**
//     打點失敗不該影響使用者正在做的事。呼叫端一律 track(...) 就走，
//     不要 await、不要 then —— 那會讓一個無關緊要的請求擋住動線。
//
//  2. **不記個資。** 沒有 IP、沒有 email。anonID 是這支自己產的隨機字串。
//
//  3. **同一個節點在同一次載入只打一次。** 後端用唯一索引做了當日去重，
//     但那要先付出一次網路往返 —— React 的 StrictMode 在開發模式下
//     會讓 effect 跑兩次（CLAUDE.md 踩過），不擋的話每個節點都是兩筆請求。

//裝置識別。存 localStorage，清掉瀏覽器資料就換一個。
//
//  它唯一的用途是把同一個人的七個節點串起來 —— 沒有它的話，
//  「一百個人各走一步」和「一個人走了一百步」在統計上長得一模一樣。
const KEY = "revelation-anon";

const anonID = () => {
  try {
    let v = localStorage.getItem(KEY);
    if (!v) {
      //  crypto.randomUUID 在 http 的舊瀏覽器上可能沒有，所以留一條退路。
      //  這個值不需要密碼學強度 —— 它只是個分組用的標籤。
      v =
        //  eslint 的 env 沒開 es2020，globalThis 會被當成未定義 ——
        //  用 window 就好，這支本來就只在瀏覽器裡跑。
        window.crypto?.randomUUID?.() ||
        `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(KEY, v);
    }
    return v;
  } catch (e) {
    //  隱私模式、封鎖 cookie 時會丟例外。沒有 ID 就不打點 ——
    //  後端收到空的 anonID 也會忽略（沒辦法去重）。
    return "";
  }
};

//這次頁面載入已經打過哪些節點
const sent = new Set();

export const track = (name, product = "") => {
  const key = `${name}:${product}`;
  if (sent.has(key)) return;

  const id = anonID();
  if (!id) return;
  sent.add(key);

  //  不 await、也不接 catch 之外的東西：這是射後不理的。
  axios
    .post("/api/event", { name, product, anonID: id })
    .catch(() => {
      //  失敗就算了。重試只會在使用者網路不好的時候雪上加霜，
      //  而少一筆打點對統計的影響遠小於拖慢他的動線。
      //  但要把這一次從 sent 拿掉 —— 不然這次載入就再也不會補打了。
      sent.delete(key);
    });
};

export default track;
